import React from 'react'
import { withIntl, Link } from '../i18n'
import { graphql, withPrefix} from 'gatsby'
import Footer from '../components/Footer'
import WithBlur from '../components/withBlur'
import A from '../components/A'
import Img from "gatsby-image"
import Carousel from 'nuka-carousel'

import styles from '../styles/servizi.module.scss'
import Layout from '../components/layout'

import rightSvg from '../resources/img/right.svg'

const createIdName = (id, name, path) => {
  if (!path || path === '' || typeof path === 'object') {
    return '-'
  }
  const extension = path.split(`.`).pop()
  return id + `-` + name + `.` + extension
}

class Servizi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      slideIndex: 1,
      dragActive: false,
      interactive: true,
      key: Math.random(),
    }
  }
  
  getAllFiles = () => {
    // console.log(this.props.data.allFile.edges)
    return this.props.data.allFile.edges;
  }

  getImage = (id, name) => {
    const buff = this.getAllFiles()
    for (let i = 0 ; i < buff.length ; i++) {
      if (
        buff[i].node.relativePath === createIdName(id, name, buff[i].node.relativePath)
      ) {
        return buff[i].node
      }
    }
    return ``
  }

  stopInteraction() {
    if (!this.state.interactive) {
      return false
    }
    this.setState({
      interactive: false,
    })
    setTimeout(() => this.setState({ interactive: true }), 400)
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.interactive !== nextState.interactive ||
      this.state.dragActive !== nextState.dragActive ||
      this.state.slideIndex !== nextState.slideIndex ||
      this.state.key !== nextState.key
    )
  }

  componentDidMount() {
    setTimeout(
      () => this.setState(() => this.setState({
        key: Math.random(),
        slideIndex: 0,
      })),
      400
    )
  }

  render() {
    const {
      interactive
    } = this.state
    const servizi = this.props.data.allCockpitServizi.edges
    let slideToShow = 1.9

    if ( typeof window !== "undefined" ) {
      if ( window.innerWidth < 600 ) {
        slideToShow = 1.7;
      }
    }
    return(
      <Layout
        fullscreen
        pageTitle="Servizi"
        pageDescription="Tutti gli strumenti utili per governare il cambiamento in un mondo in rapida evoluzione e per mantenere il proprio vantaggio competitivo"
        nochildrenmargin
        ogtags={[
          {
            name: 'title',
            content: 'GBR System™ - Soluzioni efficienti su misura',
          },
          {
            name: 'description',
            content: 'Tutti gli strumenti utili per governare il cambiamento in un mondo in rapida evoluzione e per mantenere il proprio vantaggio competitivo',
          },
          {
            name: 'image',
            content: withPrefix('/seo/gbr-systems-solutions.jpg')
          }
        ]}
      >
        <div className={styles.page}>
        <div className={styles.topbar}>
          <WithBlur>
            <span className={styles.inactive}>Soluzioni</span>
            
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Link to={'/industrie'}>
              <span className={styles.active}>Industrie</span>
            </Link>
          </WithBlur>
        </div>
        <div
          className={`vertical ` + (this.state.dragActive ? `drag-active` : ``)}
          onMouseUp={() => this.stopInteraction()}
          style={{
            pointerEvents: !interactive ? 'none' : '',
            userSelect: 'none'
          }}
        ><Carousel
              cellAlign='center'
              width="100%"
              speed={700}
              cellSpacing={20}
              slideIndex={this.state.slideIndex}
              edgeEasing="easeBounceOut"
              slidesToShow={slideToShow}
              enableKeyboardControls={true}
              wrapAround={false}
              beforeSlide={(old, slideIndex) => this.setState({ slideIndex })}
              renderCenterLeftControls={({ previousSlide }) => (
                <div />
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <A><div className={styles.arrowControls} onClick={nextSlide}><img src={rightSvg} /></div></A>
              )}
            >
              {
                servizi.map((e, i) => {
                  const node = e.node.entry;
                  const FirstBigImage = this.getImage( e.node.id, `IndexImage` )
                  if (!FirstBigImage || FirstBigImage === ``) {
                    return <div />
                  }
                  return (
                    <WithBlur>
                      <Link
                        to={`/soluzioni/` + node.Slug}
                        disabled={i !== this.state.slideIndex}
                      >
                        <div 
                          className={i === this.state.slideIndex ? styles.mousePointer : ``}
                          onClick={() => this.setState({slideIndex: i})}>
                          <div
                            key={`servizi-gallery-` + i}
                            className={this.state.dragActive ? styles.dragging : styles.drag}
                          >
                            <div
                              onMouseDown={(event) => {
                                this.setState({ dragActive: true })
                                event.preventDefault();
                              }}
                              onMouseUp={() => this.setState({ dragActive: false, })}
                              onMouseLeave={() => this.setState({ dragActive: false, })}
                              className={styles.itemParent}
                            >
                              <div className={styles.item}
                                style={{
                                  transform: i !== this.state.slideIndex ? `scale(0.9)` : `scale(1)`,
                                  opacity: 1,
                                  transformDelay: `0.4s`
                                }}>
                                <div
                                  className={styles.bg}
                                >
                                  <Img
                                    fixed={FirstBigImage.childImageSharp.fixed}
                                    fluid={FirstBigImage.childImageSharp.fluid}
                                    fadeIn={false}
                                    alt={node.Name || ""}
                                    onMouseDown={event => {
                                      event.preventDefault();
                                      event.stopPropagation();
                                    }}
                                    style={{ height: '100%' }}
                                  />
                                </div>
                                <div className={styles.centeredText}>{node.Name}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </WithBlur>
                  );
                  })
                }
            </Carousel>
          
            <div className={styles.controls}>
              {
                servizi.map((e, i) => {
                  return (<A><div
                    className={styles.itemContainer}
                    onClick={() => this.setState({ slideIndex: i })}
                    >
                    <WithBlur><div className={styles.itemControl + ' ' + (i === this.state.slideIndex ? styles.active : '')}></div></WithBlur>
                  </div></A>);
                })
              }
            </div>
        </div>
        <div className={styles.hideOnMobile}>
          <Footer infos={this.props.data.allCockpitPages.edges} variant={'fixed'} />
        </div>
        </div>
      </Layout>
    );
  }
}
export const query = graphql`
  query {
    allCockpitServizi {
      edges {
        node {
          id
          entry {
            Slug
            Title
            Name
            FirstBigImage {
              local
            }
          }
        }
      }
    }

    allFile {
      edges {
        node {
          id
          relativePath
          childImageSharp {
            fixed(width: 700, height: 560) {
              ...GatsbyImageSharpFixed
            }
            fluid(maxWidth: 1200, quality: 95) {
              ...GatsbyImageSharpFluid
              presentationWidth
            }
          }
        }
      }
    }

  allCockpitPages {
      edges {
        node {
          id
          entry {
            Slug
            Title
          }
        }
      }
    }
  }
`
export default withIntl(Servizi)
